module.exports = __webpack_public_path__ + "static/media/Wallet.a0acda07.svg";